import React, { useEffect } from 'react';
import dayjs from 'dayjs';
import { NotificationContainer } from './style';
import { INotificationMessage } from '../../store/Notifications';
import { getCurrentGasDay, formatDuration } from '../../utils/common/utils';

interface INotification {
  count: number;
  list: INotificationMessage[];
}

interface IList {
  message: string;
  messageDate: string;
  timeDifference: number;
}

const Notifications: React.FC<INotification> = ({ count, list }) => {
  const [notificationList, setNotificationList] = React.useState<IList[]>([]);

  const calculateNotificationTime = (messageDate) => {
    const messageTime = dayjs(messageDate).format('YYYY-MM-DD HH:mm:ss');
    const gasDay = getCurrentGasDay().format('YYYY-MM-DD HH:mm:ss');
    return dayjs(gasDay).diff(dayjs(messageTime));
  };

  useEffect(() => {
    const updatedList = list
      .map((item) => {
        return {
          ...item,
          timeDifference: calculateNotificationTime(item.messageDate),
        };
      })
      .sort((a, b) => a.timeDifference - b.timeDifference);
    setNotificationList(updatedList);
  }, [list]);

  if (count === 0) {
    return (
      <NotificationContainer>
        <div className='no-notifications'>
          <div className='title-wrapper'>No new notifications found</div>
        </div>
      </NotificationContainer>
    );
  }

  return (
    <NotificationContainer>
      {notificationList.map((notification) => {
        return (
          <div className='notification-message' key={notification.message}>
            {notification?.message}
            <div className='last-updated'>
              {formatDuration(notification.timeDifference)}
            </div>
          </div>
        );
      })}
    </NotificationContainer>
  );
};

export default Notifications;
